'use strict';
import React from 'react';

export default class RadioButton extends React.Component {

    constructor(props) {
        super(props);
    }

    render () {
        return (<div className="radio radio-hover-enabled" onClick={this.props.handleClick}>
            <label>
                <input type="radio" value={this.props.value} checked={this.props.checked} />
                {this.props.label}
            </label>
        </div>);
    }
    
}


// WEBPACK FOOTER //
// ./src/react/RadioButton.jsx